import * as zod from "zod/v4";
import { RateCalculatorSessionConfigSchema } from "./rate-calculator-session-config";

export const restoreRateCalculatorSession = {
  name: "restoreRateCalculatorSession" as const,
  input: zod.object({ sessionId: zod.string() }),
  output: zod.object({
    configState: RateCalculatorSessionConfigSchema.nullable(),
    error: zod.string().nullable(),
  }),
};
